export default "__VITE_ASSET___DNGUwa5__"